import { render, staticRenderFns } from "./MenuAddAttachmentButton.vue?vue&type=template&id=290c3024&"
import script from "./MenuAddAttachmentButton.vue?vue&type=script&lang=ts&"
export * from "./MenuAddAttachmentButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports